import { formatText } from '../../../../helpers/value'

export const TITLE_TABLE_HEADER = {
  RANK: {
    label: 'industryOverview.topIndustryPlayers.RANK',
    key: 'rank',
    thStyle: {},
    format: (val) => formatText(val),
  },
  COMPANY_NAME: {
    label: 'industryOverview.topIndustryPlayers.COMPANY_NAME',
    key: 'companyName',
    thStyle: {},
    format: (val) => formatText(val),
  },
  TOTAL_ASSETS: {
    label: 'industryOverview.topIndustryPlayers.TOTAL_ASSETS',
    key: 'totalAssets',
    thStyle: {
      justifyContent: 'flex-end',
    },
    format: (val) => val,
  },
  NET_REVENUE: {
    label: 'industryOverview.topIndustryPlayers.NET_REVENUE',
    corpLabel: 'industryOverview.topIndustryPlayers.CORP_NET_REVENUE',
    lifeInsLabel: 'industryOverview.topIndustryPlayers.REVENUE_INSURANCE',
    key: 'netRevenue',
    thStyle: {
      justifyContent: 'flex-end',
    },
    format: (val) => val,
  },
}

export const TOP_COMPANY = {
  top10: { label: 'Top 10', value: 10 },
  top50: { label: 'Top 50', value: 50 },
  top100: { label: 'Top 100', value: 100 },
}

export const RANK_BY = {
  netRevenue: {
    label: 'industryOverview.topIndustryPlayers.NET_REVENUE',
    corpLabel: 'industryOverview.topIndustryPlayers.CORP_NET_REVENUE',
    lifeInsLabel: 'industryOverview.topIndustryPlayers.REVENUE_INSURANCE',
    value: 1,
    isI18n: true,
  },
  totalAssets: {
    label: 'industryOverview.topIndustryPlayers.TOTAL_ASSETS',
    value: 2,
    isI18n: true,
  },
}
